import { useState, useEffect } from "react";
import "../Styles/BackToTop.css";

export default function BackToTop() {
    const [visible, setVisible] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight =
                document.documentElement.scrollHeight - window.innerHeight;

            const scrollPercent = docHeight > 0 ? scrollTop / docHeight : 0;
            setProgress(scrollPercent);
            setVisible(scrollTop > 300);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Cercle SVG : rayon 23, circonférence ≈ 144.51
    const radius = 23;
    const circumference = 2 * Math.PI * radius; // 144.51
    const offset = circumference - progress * circumference;

    return (
        <button
            className={`back-to-top ${visible ? "back-to-top--visible" : ""}`}
            onClick={scrollToTop}
            aria-label="Retour en haut de la page"
        >
            <svg
                className="back-to-top__ring"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                aria-hidden="true"
            >
                {/* Piste de fond */}
                <circle
                    cx="26"
                    cy="26"
                    r={radius}
                    fill="none"
                    stroke="rgba(255,255,255,0.2)"
                    strokeWidth="3"
                />
                {/* Anneau de progression */}
                <circle
                    cx="26"
                    cy="26"
                    r={radius}
                    fill="none"
                    stroke="rgba(255,255,255,0.9)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.1s linear" }}
                />
            </svg>

            {/* Icône flèche */}
            <span className="back-to-top__icon">
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <polyline points="18 15 12 9 6 15" />
                </svg>
            </span>
        </button>
    );
}